export class AuthPermissions {
  public static SUPER_ADMIN_PERMISSION = 'SUPER_ADMIN_PERMISSION';

  public static ADMIN_PERMISSION = 'ADMIN_PERMISSION';

  public static CREATE_INVENTORY_ITEM = 'CREATE_INVENTORY_ITEM';

  public static READ_INVENTORY_ITEM = 'READ_INVENTORY_ITEM';

  public static UPDATE_INVENTORY_ITEM = 'UPDATE_INVENTORY_ITEM';

  public static DELETE_INVENTORY_ITEM = 'DELETE_INVENTORY_ITEM';

  public static CREATE_KITCHEN_ITEM = 'CREATE_KITCHEN_ITEM';

  public static READ_KITCHEN_ITEM = 'READ_KITCHEN_ITEM';

  public static UPDATE_KITCHEN_ITEM = 'UPDATE_KITCHEN_ITEM';

  public static DELETE_KITCHEN_ITEM = 'DELETE_KITCHEN_ITEM';

  public static CREATE_BAR_ITEM = 'CREATE_BAR_ITEM';

  public static READ_BAR_ITEM = 'READ_BAR_ITEM';

  public static UPDATE_BAR_ITEM = 'UPDATE_BAR_ITEM';

  public static DELETE_BAR_ITEM = 'DELETE_BAR_ITEM';

  public static CREATE_USER = 'CREATE_USER';

  public static READ_USER = 'READ_USER';

  public static UPDATE_USER = 'UPDATE_USER';

  public static DELETE_USER = 'DELETE_USER';

  public static CHANGE_PASSWORD = 'CHANGE_PASSWORD';

  public static CREATE_UNIT = 'CREATE_UNIT';

  public static READ_UNIT = 'READ_UNIT';

  public static UPDATE_UNIT = 'UPDATE_UNIT';

  public static DELETE_UNIT = 'DELETE_UNIT';

  public static CREATE_CATEGORY = 'CREATE_CATEGORY';

  public static READ_CATEGORY = 'READ_CATEGORY';

  public static UPDATE_CATEGORY = 'UPDATE_CATEGORY';

  public static DELETE_CATEGORY = 'DELETE_CATEGORY';

  public static CREATE_SUPPLIER = 'CREATE_SUPPLIER';

  public static READ_SUPPLIER = 'READ_SUPPLIER';

  public static UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';

  public static DELETE_SUPPLIER = 'DELETE_SUPPLIER';

  public static BAR_INVENTORY_ALERT = 'BAR_INVENTORY_ALERT';

  public static KITCHEN_INVENTORY_ALERT = 'KITCHEN_INVENTORY_ALERT';

  public static READ_INVENTORY_ITEM_AVAILABILITY = 'READ_INVENTORY_ITEM_AVAILABILITY';

  public static CREATE_KITCHEN_INVENTORY_TRANSACTION = 'CREATE_KITCHEN_INVENTORY_TRANSACTION';

  public static READ_KITCHEN_INVENTORY_TRANSACTION = 'READ_KITCHEN_INVENTORY_TRANSACTION';

  public static UPDATE_KITCHEN_INVENTORY_TRANSACTION = 'UPDATE_KITCHEN_INVENTORY_TRANSACTION';

  public static DELETE_KITCHEN_INVENTORY_TRANSACTION = 'DELETE_KITCHEN_INVENTORY_TRANSACTION';

  public static CREATE_BAR_INVENTORY_TRANSACTION = 'CREATE_BAR_INVENTORY_TRANSACTION';

  public static READ_BAR_INVENTORY_TRANSACTION = 'READ_BAR_INVENTORY_TRANSACTION';

  public static UPDATE_BAR_INVENTORY_TRANSACTION = 'UPDATE_BAR_INVENTORY_TRANSACTION';

  public static DELETE_BAR_INVENTORY_TRANSACTION = 'DELETE_BAR_INVENTORY_TRANSACTION';

  public static VIEW_OPERATIONAL_ANALYTICS = 'VIEW_OPERATIONAL_ANALYTICS';

  public static VIEW_ADVANCE_ANALYTICS = 'VIEW_ADVANCE_ANALYTICS';

  public static DOWNLOAD_INVENTORY_REPORTS = 'DOWNLOAD_INVENTORY_REPORTS';

  public static READ_CHEQUE = 'READ_CHEQUE';

  public static CREATE_CHEQUE = 'CREATE_CHEQUE';

  public static UPDATE_CHEQUE = 'UPDATE_CHEQUE';

  public static DELETE_CHEQUE = 'DELETE_CHEQUE';

  public static UPDATE_CHEQUE_STATUS = 'UPDATE_CHEQUE_STATUS';

  public static DOWNLOAD_CHEQUE_REPORT = 'DOWNLOAD_CHEQUE_REPORT';

  public static CREATE_ISSUED_CHEQUE = 'CREATE_ISSUED_CHEQUE';

  public static READ_ISSUED_CHEQUE = 'READ_ISSUED_CHEQUE';

  public static UPDATE_ISSUED_CHEQUE = 'UPDATE_ISSUED_CHEQUE';

  public static UPDATE_ISSUED_CHEQUE_STATUS = 'UPDATE_ISSUED_CHEQUE_STATUS';

  public static CREATE_FACTORING_BATCH = 'CREATE_FACTORING_BATCH';

  public static READ_FACTORING_BATCH = 'READ_FACTORING_BATCH';

  public static UPDATE_FACTORING_BATCH = 'UPDATE_FACTORING_BATCH';

  public static UPDATE_FACTORING_CHEQUE_STATUS = 'UPDATE_FACTORING_CHEQUE_STATUS';

  public static READ_FACTORING_CANDIDATES = 'READ_FACTORING_CANDIDATES';

  public static READ_FACTORING_OVERDUE = 'READ_FACTORING_OVERDUE';

  public static READ_FACTORING_DEBTOR = 'READ_FACTORING_DEBTOR';

  public static DELETE_FACTORING_BATCH = 'DELETE_FACTORING_BATCH';

  public static READ_SUGGESTION = 'READ_SUGGESTION';

  public static CREATE_SUGGESTION = 'CREATE_SUGGESTION';

  public static CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';

  public static UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';

  public static DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';

  public static READ_EMPLOYEE = 'READ_EMPLOYEE';

  public static UPLOAD_EMPLOYEE = 'UPLOAD_EMPLOYEE';

  public static END_EMPLOYMENT = 'END_EMPLOYMENT';

  public static DOWNLOAD_EMPLOYEE_REPORT = 'DOWNLOAD_EMPLOYEE_REPORT';

  public static READ_ADVANCED_PAYMENT = 'READ_ADVANCED_PAYMENT';

  public static CREATE_ADVANCED_PAYMENT = 'CREATE_ADVANCED_PAYMENT';

  public static UPDATE_ADVANCED_PAYMENT = 'UPDATE_ADVANCED_PAYMENT';

  public static DELETE_ADVANCED_PAYMENT = 'DELETE_ADVANCED_PAYMENT';

  public static READ_AUDIT = 'READ_AUDIT';

  public static CREATE_LOAN_AGREEMENT = 'CREATE_LOAN_AGREEMENT';

  public static READ_LOAN_AGREEMENT = 'READ_LOAN_AGREEMENT';

  public static UPDATE_LOAN_AGREEMENT = 'UPDATE_LOAN_AGREEMENT';

  public static DELETE_LOAN_AGREEMENT = 'DELETE_LOAN_AGREEMENT';

  public static CREATE_LOAN_PAYMENT = 'CREATE_LOAN_PAYMENT';

  public static READ_LOAN_PAYMENT = 'READ_LOAN_PAYMENT';

  public static UPDATE_LOAN_PAYMENT = 'UPDATE_LOAN_PAYMENT';

  public static DELETE_LOAN_PAYMENT = 'DELETE_LOAN_PAYMENT';

  public static CREATE_PRODUCT = 'CREATE_PRODUCT';

  public static READ_PRODUCT = 'READ_PRODUCT';

  public static UPDATE_PRODUCT = 'UPDATE_PRODUCT';

  public static DELETE_PRODUCT = 'DELETE_PRODUCT';

  public static CREATE_PACKAGING_ITEM = 'CREATE_PACKAGING_ITEM';

  public static READ_PACKAGING_ITEM = 'READ_PACKAGING_ITEM';

  public static UPDATE_PACKAGING_ITEM = 'UPDATE_PACKAGING_ITEM';

  public static DELETE_PACKAGING_ITEM = 'DELETE_PACKAGING_ITEM';

  public static CREATE_PACKAGING_PURCHASE_ORDER = 'CREATE_PACKAGING_PURCHASE_ORDER';

  public static READ_PACKAGING_PURCHASE_ORDER = 'READ_PACKAGING_PURCHASE_ORDER';

  public static UPDATE_PACKAGING_PURCHASE_ORDER = 'UPDATE_PACKAGING_PURCHASE_ORDER';

  public static DELETE_PACKAGING_PURCHASE_ORDER = 'DELETE_PACKAGING_PURCHASE_ORDER';

  public static CREATE_PACKAGING_DISPATCH = 'CREATE_PACKAGING_DISPATCH';

  public static READ_PACKAGING_DISPATCH = 'READ_PACKAGING_DISPATCH';

  public static UPDATE_PACKAGING_DISPATCH = 'UPDATE_PACKAGING_DISPATCH';

  public static DELETE_PACKAGING_DISPATCH = 'DELETE_PACKAGING_DISPATCH';

  public static CREATE_PACKAGING_RETURN = 'CREATE_PACKAGING_RETURN';

  public static READ_PACKAGING_RETURN = 'READ_PACKAGING_RETURN';

  public static UPDATE_PACKAGING_RETURN = 'UPDATE_PACKAGING_RETURN';

  public static DELETE_PACKAGING_RETURN = 'DELETE_PACKAGING_RETURN';

  public static PACKAGING_INVENTORY_ALERT = 'PACKAGING_INVENTORY_ALERT';

  public static CREATE_STATIONERY_ITEM = 'CREATE_STATIONERY_ITEM';

  public static READ_STATIONERY_ITEM = 'READ_STATIONERY_ITEM';

  public static UPDATE_STATIONERY_ITEM = 'UPDATE_STATIONERY_ITEM';

  public static DELETE_STATIONERY_ITEM = 'DELETE_STATIONERY_ITEM';

  public static CREATE_STATIONERY_PURCHASE_ORDER = 'CREATE_STATIONERY_PURCHASE_ORDER';

  public static READ_STATIONERY_PURCHASE_ORDER = 'READ_STATIONERY_PURCHASE_ORDER';

  public static UPDATE_STATIONERY_PURCHASE_ORDER = 'UPDATE_STATIONERY_PURCHASE_ORDER';

  public static DELETE_STATIONERY_PURCHASE_ORDER = 'DELETE_STATIONERY_PURCHASE_ORDER';

  public static CREATE_STATIONERY_DISPATCH = 'CREATE_STATIONERY_DISPATCH';

  public static READ_STATIONERY_DISPATCH = 'READ_STATIONERY_DISPATCH';

  public static UPDATE_STATIONERY_DISPATCH = 'UPDATE_STATIONERY_DISPATCH';

  public static DELETE_STATIONERY_DISPATCH = 'DELETE_STATIONERY_DISPATCH';

  public static CREATE_STATIONERY_RETURN = 'CREATE_STATIONERY_RETURN';

  public static READ_STATIONERY_RETURN = 'READ_STATIONERY_RETURN';

  public static UPDATE_STATIONERY_RETURN = 'UPDATE_STATIONERY_RETURN';

  public static DELETE_STATIONERY_RETURN = 'DELETE_STATIONERY_RETURN';

  public static STATIONERY_INVENTORY_ALERT = 'STATIONERY_INVENTORY_ALERT';

  public static CREATE_PACKAGING_DAMAGE_DISPATCH = 'CREATE_PACKAGING_DAMAGE_DISPATCH';

  public static READ_PACKAGING_DAMAGE_DISPATCH = 'READ_PACKAGING_DAMAGE_DISPATCH';

  public static DELETE_PACKAGING_DAMAGE_DISPATCH = 'DELETE_PACKAGING_DAMAGE_DISPATCH';

  public static CREATE_STATIONERY_DAMAGE_DISPATCH = 'CREATE_STATIONERY_DAMAGE_DISPATCH';

  public static READ_STATIONERY_DAMAGE_DISPATCH = 'READ_STATIONERY_DAMAGE_DISPATCH';

  public static DELETE_STATIONERY_DAMAGE_DISPATCH = 'DELETE_STATIONERY_DAMAGE_DISPATCH';
}
